const initialState = {};

const appReducer = (state = initialState, action) => {
  return state;
};

export default appReducer;
